export const SupportedImageTypes = ["image/png", "image/jpg", "image/jpeg"];

export const SupportedVideoTypes = [
  "video/mp4",
  "video/mov",
  "video/quicktime",
];
